import createHttpInstance from "./http-common";

type ControllerName = "Auth" | "User" | "Masters" | "Restaurent" | "UserRestaurent" | "Menu" | "MenuSelection" | "PickupAddress" | "UserOrder" | "Payment";
type ModelName = "authenticate" | "CreateUser" | "ForgetPassword" | "GetCountryMaster" | "GetStateMaster" | "GetAllRestaurent" |
    "CreateRestaurent" | "UpdateRestaurent" | "GetCityMaster" | "GetZipCodeMaster" | "CreateUserRestaurent" | "GetCourseMaster" |
    "CreateMenu" | "GetAllMenu" | "CreateMenuSelection" | "GetRestaurentBySearch" | "GetMenuBySearch" | "GetBase64RestaurentFile" | "GetAllUserRestaurent"
    | "GetUserRestaurentByLoginandRestaurentSearch" | "GetUserRoleMaster" | "GetPickupAddressView" | "DecryptPassword" | "UpdateMenu" | "GetUserRestaurentByLoginIdAsync" |
    "GetMenuSelectionByRestaurentIdSearch" | "UpdateMenuSelection" | "GetUserRestaurentByLoginandRestaurentSearch" | "GetPickupAddressByRestaurentId"
    | "GetPickupAddressView" | "GetAllRestaurentView" | "GetMenuCourseItemView" | "GetMenuView" | "CreateUserOrder" | "GetAllRestaurentView" | "GetMenuCourseItemView" | "GetMenuView"
    | "GetUserOrderByUser" | "UpdateUserOrderBoxNumber" | "UpdateUserOrderStatusId" | "GetBase64UserFile" | "GetStateByCountryId" | "GetCityByStateId"
    | "GetDashboardStats" | "GetUniversityMaster" | "GetBase64MenuImage" | "GetKitchenOrder" | "UpdateMenuCourseItemById" | "GetPackedOrderView"
    | "GetUserLoginbyUserAddressDetailsView" | "ResetPasswordByGuId" | "CreateStripeDetails";

type Param = "id" | "restaurentId" | "loginId" | "date" | "EntityName" | "orderId" | "countryId" | "stateId" | "cityId" | "userRoleId" | "dayId" | "universityId" | "guId" | "menuId" | "userId" | "startDate" | "encryptedId";
type Param1 = "pickupAddressId" | "userRoleId" | "statusId" | "restaurentId" | "dayId" | "password" | "offerCode" | "startDate" | "endDate" | "userid" | "encryptedRestaurentId" | "encryptedUserid";
type Param2 = "menuId" | "pickupAddressId" | "localDateTime" | "deliveredTime" | "getDate" | "endDate";
type Param3 = "userLocalTime";


class CommonService {

    async get(ControllerName: string, ModelName: string) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithQueryParam(ControllerName: string, ModelName: string, Param: any, value: any, token?: string) {
        const httpCommon = await createHttpInstance();
        const config = token ? {
            headers: {
                ...httpCommon.defaults.headers,
                'Accept': 'application/json',
                "Content-type": "application/json",
                "Cache-Control": "no-store, no-cache, must-revalidate",
                "Authorization": 'Bearer' + ' ' + token
            }
        } : {};

        return httpCommon.get(`/${ControllerName}/${ModelName}?${Param}=${value}`, config)
            .catch((err: Error) => {
                throw err?.message;
            });
    }


    async getWithSingleParam(ControllerName: string, ModelName: string, value: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}/${value}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithDoubleParam(ControllerName: string, ModelName: string, value: any,value1:any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}/${value}/${value1}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithFourParam(ControllerName: string, ModelName: string, value: any,value1:any,value2:any,value3:any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}/${value}/${value1}/${value2}/${value3}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithTripleParam(ControllerName: string, ModelName: string, value: any,value1:any,value2:any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}/${value}/${value1}/${value2}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithDoubleQueryParam(ControllerName: string, ModelName: string, Param: Param, value: any, Param1: Param1, value1: any) {
        const httpCommon = await createHttpInstance();        
        return httpCommon.get(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param1}=${value1}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithTripleQueryParam(ControllerName: string, ModelName: string, Param: Param, value: any, Param1: Param1, value1: any, Param2: Param2, value2: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param1}=${value1}&${Param2}=${value2}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async post(ControllerName: string, ModelName: string, data: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}`, data).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithQueryParam(ControllerName: string, ModelName: string, Param: string, value: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param}=${value}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithSingleParam(ControllerName: string, ModelName: string, Param: Param, value1: any, data) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param}=${value1}`, data).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithDoubleQueryParam(ControllerName: string, ModelName: string, Param: Param, value: any, Param1: Param1, value1: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param1}=${value1}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithTribalParam(ControllerName: string, ModelName: string, Param: Param, Param1: Param1, Param2: Param2, value: any, value1: any, value2: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param1}=${value1}&${Param2}=${value2}`).catch((err: Error) => {
            throw err?.message
        });
    }


    async postWithQudraParam(ControllerName: string, ModelName: string, Param: Param, Param1: Param1, Param2: Param2, Param3: Param3, value: any, value1: any, value2: any, value3: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param1}=${value1}&${Param2}=${value2}&${Param3}=${value3}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithFormData(ControllerName: string, ModelName: string, data: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithDoubleParam(ControllerName: ControllerName, ModelName: ModelName, value1: any, value2: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}/${value1}/${value2}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async deleteWithQueryParam(ControllerName: string, ModelName: string, Param: Param, value: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.delete(`/${ControllerName}/${ModelName}?${Param}=${value}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async GetBase64ProfileImage(ControllerName: ControllerName, ModelName: ModelName, Param: Param, value: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}?${Param}=${value}`).catch((err: Error) => {
            throw err?.message;
        })
    }

    async putWithQueryParam(ControllerName: string, ModelName: string, Param: any, value: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.put(`/${ControllerName}/${ModelName}?${Param}=${value}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async putWithDoubleQueryParam(ControllerName: string, ModelName: string, Param: any, value: any, Param1: any, value1: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.put(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param1}=${value1}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async putWithTribleQueryParam(ControllerName: string, ModelName: string, Param: any, value: any, Param1: any, value1: any, Param2: any, value2: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.put(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param1}=${value1}&${Param2}=${value2}`).catch((err: Error) => {
            throw err?.message
        });
    }

}

export default new CommonService();